import { configureStore } from '@reduxjs/toolkit';
import authorizationReducer from './authorization/authorizationSlice';
import undoableExpReducer from './ExportEdit/exportEditSlice';

export const store = configureStore({
    reducer: {
        authorization: authorizationReducer,
        exp: undoableExpReducer
    },
});